// Overland Vehicles — expedition truck / built platform imagery.
//
// Iteration 109: Owner-approved overland vehicle photography landed via
// the canonical manifest (see /lib/photos/manifest.js).  This module now
// only exposes true expedition vehicle imagery (27North, EarthRoamer SX,
// RAM 5500 build, 4x4 cab-over).  The previous Newell / Prevost
// stand-ins have been retired.
import { _ASSET_BASE } from "./_base";

const OV_HERO      = `${_ASSET_BASE}/1t36s78y_IMG_5625.jpeg`; // 27North · Ford · desert motion
const OV_ACCENT    = `${_ASSET_BASE}/hm37deil_IMG_5626.jpeg`; // RAM 5500 build · prairie sunset
const OV_GALLERY_1 = `${_ASSET_BASE}/fueyzmjn_IMG_5627.jpeg`; // EarthRoamer SX beige · Chevy · granite
const OV_GALLERY_2 = `${_ASSET_BASE}/yu77yrhm_IMG_5628.jpeg`; // 4x4 cab-over · salt flats sunset
const OV_GALLERY_3 = `${_ASSET_BASE}/l71imx7v_IMG_5629.jpeg`; // EarthRoamer SX blue · forest sunset

export const OVERLAND_VEHICLE_PHOTOS = [
  OV_HERO,
  OV_ACCENT,
  OV_GALLERY_1,
  OV_GALLERY_2,
  OV_GALLERY_3,
];

const overlandVehicles = {
  hero: OV_HERO,
  accent: OV_ACCENT,
  gallery: [OV_GALLERY_1, OV_GALLERY_2, OV_GALLERY_3],
  card: OV_HERO,
  social: OV_HERO,
};
export default overlandVehicles;
